<template>
  <div class="index-container" :style="{ backgroundImage: 'url(' + img + ')' }">
    <div class="logo-title-box">
      <div class="title-text">思远销售通知系统</div>
      <div class="title-image" style="background-image: url(assets/mobileTitle.png);"></div>
    </div>
    <div class="login-module">
      <div class="login-title">请登录</div>
      <div class="prompt-message">登录失败请检查您的用户名和密码!</div>
      <div class="login-input-box">
        <div class="input-title">账号：</div>
        <el-input v-model="account" prefix-icon="el-icon-user" placeholder="请输入账号"></el-input>
      </div>
      <div class="login-input-box">
        <div class="input-title">密码：</div>
        <el-input prefix-icon="el-icon-lock" v-model="password" placeholder="请输入密码" show-password></el-input>
      </div>
      <div class="login-button-box">
        <div class="login-text" @click="login">登录</div>
      </div>
    </div>
  </div>
</template>
<script>
import backgroundImg from '../assets/back.png';
import api from '../api/api';
import { mapState, mapMutations } from 'vuex';
import {
  apiCollection,
  apiResource,
  apiFormSubmit,
  apiDelete,
  apiPut,
  apiCollectionbill,
  apiResourcebill
} from '../api/index';
export default {
  data() {
    return {
      img: backgroundImg,
      password: '',
      account: ''
    };
  },
  mounted() {},
  methods: {
    ...mapMutations(['getUserInfo']),
    login() {
      if (!this.account) {
        this.$message.warning('请输入账号！');
      } else if (!this.password) {
        this.message.warning('请输入密码！');
      } else {
        const params = {
          username: this.account,
          password: this.password
        };
        api.login(params).then(res => {
          const result = res.data;
          if (result.code === 0) {
            this.getUserInfo(result.data.user_info.username);
            window.localStorage.setItem('saleIsLogin', true);
            const arr = [
              apiCollection,
              apiResource,
              apiFormSubmit,
              apiDelete,
              apiPut,
              apiCollectionbill,
              apiResourcebill
            ];
            arr.forEach(item => {
              item.defaults.headers['x-token'] = result.data.cookie;
            });
            localStorage.setItem('x-token', result.data.cookie);
            this.$message.success('登录成功');
            this.$router.replace({ path: '/' });
          } else {
            this.password = '';
            this.$message.warning('账号密码有误！');
          }
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.index-container {
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: rgba(236, 239, 244, 1);

  .logo-title-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 100px 0 94px;
  }
  .logo-image {
    width: 101px;
    height: 107px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .title-image {
    display: none;
  }
  .title-text {
    padding-left: 40px;
    font-size: 50px;
    color: #ffffff;
    font-weight: bold;
    letter-spacing: 2px;
    text-shadow: 0px 0px 10px rgba(102, 54, 13, 0.6);
  }

  .have-message {
    height: 513px;
  }
  .login-module {
    width: 400px;
    margin: 0 auto;
    padding: 38px 56px 50px;
    background-color: #ffffff;
  }
  .prompt-message {
    display: none;
    width: 100%;
    height: 40px;
    padding: 0 20px;
    margin-bottom: 20px;
    line-height: 40px;
    font-size: 16px;
    color: #548ea2;
    background-color: #ffc6c6;
    border-radius: 4px;
  }
  .login-title {
    position: relative;
    margin-bottom: 50px;
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    line-height: 22px;
  }
  .login-title::after {
    position: absolute;
    bottom: -16px;
    left: 45%;
    width: 40px;
    height: 4px;
    background: #548ea2;
    content: '';
  }
  .login-input-box {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .input-title {
    padding-right: 20px;
    font-size: 16px;
  }
  .code-title {
    padding-right: 4px;
  }
  .input-pattern {
    flex: 1;
    padding: 0 24px;
    line-height: 48px;
    outline: none;
    background: rgba(250, 252, 254, 1);
    border: 1px solid rgba(223, 232, 241, 1);
    border-radius: 4px;
  }
  .code-input {
    width: 100px;
    line-height: 38px;
  }
  .again-button {
    margin-left: 16px;
    font-size: 14px;
    color: #666666;
    text-align: center;
    cursor: pointer;
  }
  .again-button:hover {
    color: #548ea2;
  }
  .code-image {
    width: 90px;
    height: 38px;
    margin-left: 16px;
    line-height: 38px;
    font-size: 16px;
    text-align: center;
    border: 1px solid rgba(223, 232, 241, 1);
    border-radius: 4px;
  }
  /deep/ {
    .el-input {
      flex: 1;
    }
    .el-input--prefix .el-input__inner {
      border-color: #548ea2;
    }
  }
  .login-button-box {
    position: relative;
    width: 100%;
    height: 50px;
    margin-bottom: 22px;
    background: linear-gradient(90deg, #548ea2 0%, #548ea2 100%);
    border-radius: 4px;
    cursor: pointer;
  }
  .login-button {
    position: absolute;
    width: 100%;
    height: 100%;
    outline: none;
    border: none;
    background-color: transparent;
  }
  .login-text {
    position: absolute;
    top: 16px;
    width: 100%;
    font-size: 18px;
    line-height: 18px;
    color: #ffffff;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue